export default __webpack_public_path__ + "static/media/screenshot.8e6ff26b.png";